import React from 'react';
import {
  CCard,
  CCardBody,
  CContainer,
} from '@coreui/react';
import Navigation from '../components/Navigation';
import WelcomeView from './WelcomeView';
import RealtimeView from './RealtimeView';
import HistoryView from './HistoryView';
import useDashboardRealtimeViewModel from '../viewmodels/DashboardRealtimeViewModel';
import useDashboardHistoryViewModel from '../viewmodels/DashboardHistoryViewModel';
import useDashboardLicenseViewModel from '../viewmodels/DashboardLicenseViewModel';


const DashboardView = () => {
  const { 
    licenses,
    selectedLicense,
    isLicenseLoading,
    licenseError,
    handleLicenseSelect
  } = useDashboardLicenseViewModel();
  
  const {
    isRealtimeLoading,
    realtimeError,
    registerNumByHour,
    registerNumByCountry,
    usageByHour,
    usageByCountry,
  } = useDashboardRealtimeViewModel(selectedLicense);

  const {
    dateRange,
    setDateRange,
    isHistoryLoading,
    historyError,
    registerNum,
    usage,
    deviceActiveRatio,
    usageDistribution,
    platformDistribution,
    appDistribution,
  } = useDashboardHistoryViewModel(selectedLicense);


  return (
    <div className="bg-light min-vh-100">
      <Navigation />
      <CContainer fluid className="py-4">
        <CCard className="shadow-sm">
          <CCardBody>
            <WelcomeView 
              licenses={licenses}
              selectedLicense={selectedLicense}
              isLoading={isLicenseLoading}
              error={licenseError}
              handleLicenseSelect={handleLicenseSelect}
            />
          </CCardBody>
        </CCard>
        
        {selectedLicense && (
          <>
            <CCard className="shadow-sm mt-4">
              <CCardBody>
                <RealtimeView
                  isLoading={isRealtimeLoading}
                  error={realtimeError}
                  data={({
                    registerNumByHour,
                    registerNumByCountry,
                    usageByHour,
                    usageByCountry,
                  })}
                />
              </CCardBody>
            </CCard>
            <CCard className="shadow-sm mt-4">
              <CCardBody>
                <HistoryView
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  isLoading={isHistoryLoading}
                  error={historyError}
                  data={({
                    registerNum,
                    usage,
                    deviceActiveRatio,
                    usageDistribution,
                    platformDistribution,
                    appDistribution,
                  })}
                />
              </CCardBody>
            </CCard>
          </>
        )}
      </CContainer>
    </div>
  );
};

export default DashboardView;